import TableCell from "@tiptap/extension-table-cell";
export const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      colwidth: {
        default: null,
        parseHTML: (element) => {
          const colwidth = element.getAttribute("colwidth");
          return colwidth
            ? colwidth.split(",").map((w) => parseInt(w, 10))
            : null;
        },
        renderHTML: (attributes) => {
          return {
            colwidth: attributes.colwidth
              ? attributes.colwidth.join(",")
              : null,
          };
        },
      },
      styles: {
        default: null,
        renderHTML: (attributes) => {
          const width = attributes.colwidth?.[0];
          return {
            style: `min-width: ${width || 100}px; background-color: #FFFFFF; ${
              width ? `width: ${width}px;` : ""
            }`,
          };
        },
      },
    };
  },
});
